"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DocFlux = _interopRequireDefault(require("./DocFlux"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A Document is a wrapper to a component where you can call the create method to
 * create the document object.  Generally you will inherit from this class to create
 * document type specific Documents.  This class will create the root component, render
 * the component tree, then transform the component tree passing a document builder object
 * created in `createDocument`.  It will return the document builder object afterwards.
 * @module Document
 */
var Document = /*#__PURE__*/function () {
  function Document() {
    _classCallCheck(this, Document);
  }

  _createClass(Document, null, [{
    key: "create",

    /**
     * The component to render
     * @static
     * @abstract
     */

    /**
     * Creates the document builder for transforming
     * @static
     * @function
     * @abstract
     */

    /**
     * Creates the document from the document builder.  This
     * Gets returned on create.
     * @static
     * @function
     * @abstract
     */

    /**
     * Prop types for validation
     * @static
     */

    /**
     * Default props
     * @static
     */

    /**
     * Creates a document
     * @static
     * @function
     * @param {object} initialProps The props to pass to the component
     * @return {object} The document generated
     */
    value: function create(initialProps) {
      var props = _DocFlux["default"].parseProps(initialProps, this.defaultProps);

      _DocFlux["default"].validateProps(props, this.propTypes, this.constructor.name);

      var component = {
        node: this.component,
        props: props
      };

      var DOM = _DocFlux["default"].render(component, this.parser);

      var doc = _DocFlux["default"].transform(DOM, this.createBuilder(props));

      return this.createDocument(doc, props);
    }
  }]);

  return Document;
}();

exports["default"] = Document;

_defineProperty(Document, "component", null);

_defineProperty(Document, "createBuilder", function () {
  return null;
});

_defineProperty(Document, "createDocument", function () {
  return null;
});

_defineProperty(Document, "propTypes", {});

_defineProperty(Document, "defaultProps", {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/Document.js
// module id = 45
// module chunks = 0